import type { ComboboxOption } from '@/components/Combobox/types';
import type { DeviceCatalog } from '../-query/type';
export type DeviceCatalogOption = ComboboxOption & {
  id: string;
  catalogCode: string;
  deviceType: string;
  avatarUrl?: string;
  disabled?: boolean;
};
export const convertToDeviceCatalogOption = (catalog: DeviceCatalog): DeviceCatalogOption => ({
  value: catalog.id,
  label: catalog.name,
  id: catalog.id,
  catalogCode: catalog.catalogCode ?? '',
  deviceType: catalog.deviceType,
  avatarUrl: catalog.avatarUrl ?? undefined,
  disabled: false
});